//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EVENTS } from '@/scripts/constants/css-classes'

export default {
  name: 'rb-infographic-box',
  props: {
    backgroundColor: {
      type: String,
      default: 'light-grey',
    },
  },
  computed: {
    getBackgroundColorClass() {
      return `rb-infographic-box--${this.backgroundColor}`
    },
  },
  mounted() {
    if (document.getElementsByClassName('promo-stripes')) {
      this.setHeightTitle()
      window.addEventListener(EVENTS.RESIZE, this.setHeightTitle)
    }
  },
  beforeDestroy() {
    if (document.getElementsByClassName('promo-stripes')) {
      this.setHeightTitle()
      window.removeEventListener(EVENTS.RESIZE, this.setHeightTitle)
    }
  },
  methods: {
    setHeightTitle() {
      const boxes = document.querySelectorAll('.rb-infographic-box')
      if (boxes.length > 0) {
        this.cleanCustomHeight(boxes)

        const firstBox = boxes[0]
        const boxWidth = firstBox.offsetWidth
        const parent = firstBox.parentElement.parentElement
        const parentWidth = parent.offsetWidth

        const boxesInRow = Math.floor(parentWidth / boxWidth)

        const rows = []
        let index = 1
        let row = []
        for (const box of boxes) {
          row.push(box)
          index++

          if (index > boxesInRow) {
            rows.push(row)
            index = 1
            row = []
          }
        }
        for (const row of rows) {
          const { maxTitle, maxText } = this.getHeighestBoxTitles(row)
          this.updateHeightInRow(row, { maxTitle, maxText })
        }
      }
    },
    cleanCustomHeight(boxes) {
      for (const box of boxes) {
        const title = box.querySelector('h2.text-module__title')
        if (title) {
          title.style.height = 'auto'
        }

        const text = box.querySelector('div.text-module__excerpt-block')
        if (text) {
          text.style.height = 'auto'
        }
      }
    },
    getHeighestBoxTitles(row) {
      let maxTitle = 0,
        maxText = 0
      for (const box of row) {
        const title = box.querySelector('h2.text-module__title')
        const text = box.querySelector('div.text-module__excerpt-block')

        if (!title || !text) {
          continue
        }

        const heightText = text.offsetHeight
        const heightTitle = title.offsetHeight

        if (heightTitle > maxTitle) {
          maxTitle = heightTitle
        }

        if (heightText > maxText) {
          maxText = heightText
        }
      }

      return { maxTitle, maxText }
    },
    updateHeightInRow(row, { maxTitle, maxText }) {
      for (const box of row) {
        const title = box.querySelector('h2.text-module__title')
        const text = box.querySelector('div.text-module__excerpt-block')

        if (!title || !text) {
          continue
        }

        title.style.height = `${maxTitle}px`
        text.style.height = `${maxText}px`
      }
    },
  },
}
